/**
 * @generated SignedSource<<f35cb7e112a15c9607dc5aabcfcc453f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HorizontalNavBoardHeader_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs" | "extraComponentsFar_horizontalNav" | "ui_navigationBoardActionMenu_BoardActions">;
  readonly " $fragmentType": "HorizontalNavBoardHeader_project";
};
export type HorizontalNavBoardHeader_project$key = {
  readonly " $data"?: HorizontalNavBoardHeader_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTMPBoardRoute"
    }
  ],
  "kind": "Fragment",
  "name": "HorizontalNavBoardHeader_project",
  "selections": [
    {
      "condition": "isTMPBoardRoute",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_navigationBoardActionMenu_BoardActions"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "extraComponentsFar_horizontalNav"
    },
    {
      "kind": "FragmentSpread",
      "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "4d7831624d138ccfc8b65bab016f6e93";

export default node;
